var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!!_vm.columnSchema.headerFlag && (!!_vm.columnSchema.children && _vm.columnSchema.children.length > 0)) ? _c('el-table-column', {
    attrs: {
      "label": _vm.columnSchema.label,
      "align": _vm.columnSchema.align ? _vm.columnSchema.align : 'center'
    }
  }, [_vm._l((_vm.columnSchema.children), function(child, idx) {
    return [_c('table-high-level-column', {
      attrs: {
        "column-schema": child,
        "data-table-ref": _vm.dataTableRef,
        "column-index": idx
      }
    })]
  })], 2) : (!_vm.columnSchema.headerFlag && (_vm.columnSchema.show !== false) && !_vm.columnSchema.children) ? _c('el-table-column', {
    key: _vm.columnSchema.columnId,
    attrs: {
      "prop": _vm.columnSchema.prop,
      "label": _vm.columnSchema.label,
      "sortable": _vm.getSortable(_vm.columnSchema),
      "fixed": !_vm.columnSchema.fixed ? false : _vm.columnSchema.fixed,
      "align": _vm.columnSchema.align ? _vm.columnSchema.align : 'center',
      "formatter": _vm.formatterValue,
      "format": _vm.columnSchema.format,
      "show-overflow-tooltip": true,
      "min-width": _vm.columnSchema.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.columnSchema.formatS === 'render' && !!_vm.columnSchema.render) ? [_c('table-column-custom-render', {
          attrs: {
            "row": scope.row,
            "column": _vm.columnSchema,
            "data-table-ref": _vm.dataTableRef,
            "row-index": scope.$index,
            "column-index": _vm.columnIndex,
            "renderFn": _vm.getColumnRender(scope.row, _vm.columnSchema)
          }
        })] : (!!_vm.columnSchema.formatS && (_vm.columnSchema.formatS !== 'renders')) ? [_c('span', [_vm._v(_vm._s(_vm.formatterValue(scope.row, _vm.columnSchema, scope.row[_vm.columnSchema.prop])))])] : [_c('span', [_vm._v(_vm._s(scope.row[_vm.columnSchema.prop]))])]]
      }
    }])
  }) : _vm._e()
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1430e384","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-render/table-high-level-column.vue
// module id = null
// module chunks = 